import { Component, Injector } from '@angular/core';
import { RoutingDataService } from '../../angular-common/routing-data.service';
import { buildSelectableOptions } from '../forms/forms-util';
import { SecurityDataService } from '../../angular-common/security-data.service';

@Component({
  selector: 'app-dashboard-menu',
  templateUrl: './dashboard-menu.component.html',
  styleUrls: ['./dashboard-menu.component.scss']
})
export class DashboardMenuComponent {

  public nodes;
  
  constructor(
    public routingDataService: RoutingDataService,
    protected _injector: Injector
  ) {
    this.nodes = buildSelectableOptions(this.routingDataService.navigationTree, null, this._injector.get(SecurityDataService).userProfile).selectableOptions
  }
}
